import { createComponent } from '@carvana/merch-components';
import HeartIcon, {
  OwnProps as HeartIconProps
} from '~/icons/HeartWithBorderThin';
import ShareIcon from '~/icons/ShareAlt';

export const ActionsContainer = createComponent('div', {
  className: 'flex items-center gap-16'
});

export const ShareButton = createComponent(ShareIcon, {
  className: 'pointer-events-auto flex h-16 w-16 m:h-24 m:w-24'
});

export const Heart = createComponent<HeartIconProps & { big: boolean }>(
  HeartIcon,
  props => ({
    className: props.big ? 'h-24 w-24' : 'h-[18px] w-[18px] m:h-24 m:w-24'
  })
);
